import React from 'react';
import styles from './steps.module.css';

/** kaneai TimelineDot: 16×16 wrapper, 8×8 dot + 2px halo; spinner while
 * executing (autoplay). Shared by the block rows and the if/else + until
 * container cards. */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TimelineDot(_ref) {
  var status = _ref.status;
  if (status === 'executing') {
    return /*#__PURE__*/_jsx("span", {
      className: styles.dotWrap,
      "aria-hidden": "true",
      children: /*#__PURE__*/_jsxs("svg", {
        className: styles.dotSpinner,
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        children: [/*#__PURE__*/_jsx("circle", {
          cx: "6",
          cy: "6",
          r: "5",
          stroke: "#d0d7de",
          strokeWidth: "1.5"
        }), /*#__PURE__*/_jsx("path", {
          d: "M11 6a5 5 0 0 0-5-5",
          stroke: "#0969DA",
          strokeWidth: "1.5",
          strokeLinecap: "round"
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx("span", {
    className: styles.dotWrap,
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("span", {
      className: "".concat(styles.dot, " ").concat(styles["dot_".concat(status)])
    })
  });
}